export var defaultLineHeight = 16;
export var defaultElementHeight = 11;
export var defaultLayersPadding = 3;
export var defaultTimelineLayerLineHeight = defaultLineHeight;